<div class="icu-selection-item-dropdown">
  <mat-form-field appearance="outline" class="icu-search-box">
    <mat-select [(value)]="itemsWithSelection.selected" placeholder="{{title}}"  [disabled]="disabled" disableOptionCentering
      (selectionChange)="onSelectionChange($event)">
      <mat-option *ngFor="let item of itemsWithSelection.items" [value]="item">
        <span>{{item[displayPropertyName]}}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
